import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Container } from '@mui/material';
import PostDetalhe from '../../components/Instituicoes/PostDetalhe';
import { getPost } from '../../services/postService'; // Corrigido de postsService para postService
import { useNotificacao } from '../../contexts/NotificacaoContext'; // Corrigido o caminho

const PostDetalhePage = () => {
  const { instituicaoId, postId } = useParams();
  const [post, setPost] = useState(null);
  const { adicionarNotificacao } = useNotificacao();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const data = await getPost(instituicaoId, postId);
        setPost(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes do post:', error);
        adicionarNotificacao('Erro ao carregar o post', 'error');
      }
    };

    fetchPost();
  }, [instituicaoId, postId, adicionarNotificacao]);

  if (!post) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Container>
      <PostDetalhe post={post} />
    </Container>
  );
};

export default PostDetalhePage;